import React, { useEffect, useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import EventCard from "./eventCards";
import EventCardSkeleton from "./EventCardSkeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { getEvents } from "../../services/apiService";
import img1 from "../../assets/images/events/event-1.png";
import img2 from "../../assets/images/events/event-2.png";
import img3 from "../../assets/images/events/event-3.png";
import img4 from "../../assets/images/events/event-4.png";
// import eventCardImg from "../../assets/images/events/mcube-card.png";
import eventCardImg from "../../assets/images/events/Kairali-uk-card.png";
import pranayanil from "../../assets/images/PRANAYANILA-thumbnail.png";
import { createEventSlug } from "../../utils/urlUtils";

const EventsSection = ({ title, showAsGrid = false }) => {
  const [events, setEvents] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showArrows, setShowArrows] = useState(false);

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);

  // Function to determine if arrows should be shown
  const shouldShowArrows = (eventCount) => {
    if (!eventCount || eventCount === 0) return false;
    
    const screenWidth = window.innerWidth;
    let slidesPerView;
    
    // Match the breakpoints from Swiper config
    if (screenWidth < 768) {
      slidesPerView = 1; // Mobile: 1 slide
    } else if (screenWidth < 1024) {
      slidesPerView = 2; // Tablet: 2 slides
    } else if (screenWidth < 1200) {
      slidesPerView = 3; // Desktop: 3 slides
    } else {
      slidesPerView = 4; // Large desktop: 4 slides
    }
    
    // Show arrows only if we have more events than can fit in current viewport
    return eventCount > slidesPerView;
  };

  useEffect(() => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.params.navigation.prevEl = prevRef.current;
      swiperRef.current.swiper.params.navigation.nextEl = nextRef.current;
      swiperRef.current.swiper.navigation.init();
      swiperRef.current.swiper.navigation.update();
    }
  }, []);

  // Update arrow visibility on window resize and when events change
  useEffect(() => {
    const updateArrowVisibility = () => {
      if (events && events.length > 0) {
        setShowArrows(shouldShowArrows(events.length));
      } else {
        setShowArrows(false);
      }
    };

    updateArrowVisibility();

    const handleResize = () => {
      updateArrowVisibility();
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [events]);


  useEffect(() => {
    setTimeout(() => {

      const fetchEvent = async () => {
        try {
          const response = await getEvents();
          const apiData = response.data; // This contains the array of events from the API
          
          // Transform the API data to match the expected format
          // Filter events to only show published events
          const formattedEvents = apiData
            .filter((event) => event.status === "publish")
            .map((event) => {
              // Use the slug from API instead of generating from title
              const eventSlug = event.slug || createEventSlug(event.title); // Fallback to title-based slug if API slug is missing
              sessionStorage.setItem(`event_${eventSlug}`, JSON.stringify(event));
              
              return {
                id: event._id,
                imageUrl: eventCardImg, // Using default image since API doesn't provide images yet
                imageUrl1: pranayanil,
                title: event.title,
                description: event.description,
                date: event.date,
                time: event.time, // Preserve original time
                location: event.venue,
                eventUrl: `/events/${eventSlug}`
              };
            });
          
          setEvents(formattedEvents);
          setLoading(false);
          console.log('API Response:', response);
          console.log('Formatted Events:', formattedEvents);
        } catch (error) {
          console.error("Error fetching events:", error);
          setLoading(false);
          setEvents([]); // Set to empty array on error
        }
      };
      
      // Call the fetchEvent function to get real data from API
      fetchEvent();

      // Remove the static mock data since we're now using real API data
    }, 2000); 
  }, []);

  if (showAsGrid) {
    return (
      <section className="events-section py-md-5 pb-5">
        <div className="d-flex align-items-center justify-content-center mb-4">
          <h3 className="mb-0 text-center">
            {title}
          </h3>
        </div>

        <div className="row g-4 ">
          {loading
            ? [...Array(8)].map((_, index) => (
                <div key={index} className="col-12 col-sm-6 col-lg-4 col-xl-3">
                  <EventCardSkeleton />
                </div>
              ))
            : events && events.map((event) => (
                <div key={event.id} className="col-12 col-sm-6 col-lg-4 col-xl-3">
                  <EventCard
                    imageUrl1={event.imageUrl1}
                    title={event.title}
                    date={event.date}
                    location={event.location}
                    description={event.description}
                    eventUrl={event.eventUrl}
                  />
                </div>
              ))}
        </div>
      </section>
    );
  }

  return (
    <section className="events-section py-5 position-relative upcoming-events-custom-button">
      <div className="d-flex align-items-center justify-content-between mb-0">
        <h3 className="mb-0">
          {title}
          {/* <FontAwesomeIcon className="ms-2 title-icon" icon={faChevronRight} /> */}
        </h3>

        {/* Custom Navigation Buttons - Only show if arrows should be visible */}
        {/* {showArrows && ( */}
          {/* // <div className="swiper-nav-buttons ">
          //   <button ref={prevRef} className="swiper-button-prev-custom">
          //     <FontAwesomeIcon icon={faChevronRight} className="rotate-left arrow-icons" />
          //   </button>
          //   <button ref={nextRef} className="swiper-button-next-custom arrow-icons">
          //     <FontAwesomeIcon icon={faChevronRight} />
          //   </button>
          // </div> */}
        {/* // )} */}
      </div>

      <Swiper 
        ref={swiperRef}
        modules={[Navigation, Autoplay]}
        slidesPerView={4}
        spaceBetween={16}
        autoplay={false}
        navigation={showArrows}
        className="py-4"
        breakpoints={{
            320: { slidesPerView: 1 }, 
            768: { slidesPerView: 2 }, 
            1024: { slidesPerView: 3 }, 
            1200: { slidesPerView: 4 }, 
          }}
      >
        {loading
          ? [...Array(4)].map((_, index) => (
              <SwiperSlide key={index}>
                <EventCardSkeleton />
              </SwiperSlide>
            ))
          : events.map((event) => (
              <SwiperSlide key={event.id}>
                <EventCard
                  imageUrl={event.imageUrl1}
                  title={event.title}
                  date={event.date}
                  location={event.location}
                  description={event.description}
                  eventUrl={event.eventUrl}
                />
              </SwiperSlide>
            ))}
      </Swiper>
    </section>
  
  );
};

export default EventsSection;
